import { http } from './config'

export default {

  getAllLocalityEmails: (localityId) => {
    return http.get('locality_emails/?locality_id=' + localityId)
  },

  getLocalityEmailsById: (localityEmailId) => {
    return http.get('locality_emails/' + localityEmailId)
  },

  createLocalityEmails: (localityEmailsparams) => {
    return http.post('locality_emails', {
      email: localityEmailsparams.email,
      locality_id: localityEmailsparams.locality_id
    }
  )},

  updateLocalityEmails: (localityEmailsparams) => {
    return http.put('locality_emails/' + localityEmailsparams.id, {
      email: localityEmailsparams.email
    }
  )},

  deleteLocalityEmails: (localityEmailId) => {
    return http.delete('locality_emails/' + localityEmailId)
  }
}
